import React from 'react'
import type { ProbeResult } from '../lib/api'
import { kindOf } from '../lib/api'

export function AttentionStrip({ probes }: { probes: ProbeResult[] }) {
  const items = probes.filter((p) => kindOf(p) !== 'up')
  if (!items.length) return null

  return (
    <section className="glass-panel rounded-md p-4 border border-amber-400/20">
      <div className="text-[10px] tracking-[0.28em] text-amber-400 mb-3">NEEDS ATTENTION</div>
      <div className="space-y-2">
        {items.map((p) => {
          const k = kindOf(p)
          return (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between gap-3 px-2 py-2 rounded hover:bg-white/5"
            >
              <div className="min-w-0">
                <div className="text-sm text-zinc-100 truncate">{p.label || p.name}</div>
                <div className="text-[10px] text-zinc-500 truncate">{p.status} · HTTP {p.http} · {p.ms}ms</div>
              </div>
              <span className={`text-[10px] tracking-widest ${k === 'gated' ? 'text-amber-400' : 'text-[#f43f5e]'}`}>
                {k === 'gated' ? 'GATED' : 'DOWN'}
              </span>
            </a>
          )
        })}
      </div>
    </section>
  )
}
